import Store from '~/store'
import * as KEYS from './grid.utils.keys'
import dialog from '~/plugins/nikan-dialog-plugin'

const call = (func, name) => (...args) => func().apply(this, [name].concat(args))
export const store = ({
  configTable: call(() => Store.dispatch, 'clipboard/configTable'),
  addTableItem: call(() => Store.dispatch, 'clipboard/addTableItem'),
  addTableItemRange: call(() => Store.dispatch, 'clipboard/addTableItemRange'),
  removeItemFromTable: call(() => Store.dispatch, 'clipboard/removeItemFromTable'),
  clearItemsInTable: call(() => Store.dispatch, 'clipboard/clearItemsInTable')
})

export default table => {
  const copyToClipboard = (append) => {
    let pureRecords = table.init_getPureRecords(table.localValue)

    if (!append) {
      store.clearItemsInTable(table.settings.stateUID)
    }

    store.addTableItemRange({
      stateUID: table.settings.stateUID,
      items: pureRecords
    })
  }
  const pasteFromClipboard = () => {
    if (!table.itemsInClipboard.length) {
      dialog({
        title: table.$t('notifications.titles-error'),
        body: table.$t('table.msg.nothing-to-paste'),
        isPrimary: true,
        type: 'error'
      })

      return
    }

    let wait = table.$wait(table.$el)

    let sec = table.itemsInClipboard.length * 10
    sec = sec >= 300 && sec < 510 ? 510 : sec
    sec = sec >= 550 ? 550 : sec
    sec = sec < 300 ? 0 : sec

    table.defer(() => {
      let index = table.activeRowIndex + 1
      let displayOrder = (table.filteredData[index] || {
        [KEYS.SYSFIELDS_DISPLAYORDER]: 0
      })[KEYS.SYSFIELDS_DISPLAYORDER]
      for (let i = table.itemsInClipboard.length - 1; i >= 0; i--) {
        let record = table.itemsInClipboard[i]
        var newObj = table.row_getClonedObjectAsNew(
          record,
          table.activeRowIndex
        )
        newObj.displayOrder = displayOrder

        if (table.row_tryAddRecordAt(index, newObj, i === 0)) {
          store.removeItemFromTable({
            stateUID: table.settings.stateUID,
            item: record
          })
        }
      }

      wait.end()
    }, sec)
  }
  const clearTableClipboard = () => {
    store.clearItemsInTable(table.settings.stateUID)
  }
  const selectInTable = () => {
    if (!table.itemsInClipboard.length) return

    table.value_removeAll()
    for (let i = 0; i < table.itemsInClipboard.length; i++) {
      table.value_tryAdd(table.itemsInClipboard[i])
    }
  }
  const replaceInTable = () => {
    if (!table.itemsInClipboard.length) return

    let deletedRows = table.localValue.map((item, i) => {
      let index = table.clonedData.indexOf(item)

      return {
        index,
        deleted: table.row_silentDeleteAt(index)
      }
    })

    table.activeRowIndex = deletedRows.reduce(
      (maxIndex, item) => Math.max(maxIndex, item.index),
      0
    )
    return pasteFromClipboard()
  }
  const pasteInTable = () => {
    if (!table.itemsInClipboard.length) return

    return pasteFromClipboard()
  }

  return {
    copyToClipboard,
    pasteFromClipboard,
    clearTableClipboard,
    selectInTable,
    replaceInTable,
    pasteInTable
  }
}
